export const useEmptyRoomTableColumns = () => [
  {
    headerName: "Classroom ID",
    field: "id",
    width: 150,
  },
  {
    headerName: "Lớp học",
    field: "classroom",
    width: 150,
  },
  {
    headerName: "Tòa nhà",
    field: "building",
    width: 120,
  },
  {
    headerName: "Số lượng chỗ ngồi",
    field: "quantityMax",
    width: 170,
  },
  {
    headerName: "Mô tả",
    field: "description",
    width: 300,
  },
];
